import React, { useState, useEffect, useCallback } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../CSS/SlickCraousel.css'

export default function SlickCraousel() {
  const [images, setImages] = useState([]);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFadeIn(true);
        } else {
          setFadeIn(false);
        }
      },
      { threshold: 0.1 }
    );

    const target = document.querySelector('.wrapper');
    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, []);

  const fetchGalleryImage = useCallback(async () => {
    try {
      const response = await fetch(`/api/getGalleryImage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ activeInactive: 1 }),
      });

      if (response.ok) {
        const Data = await response.json();
        setImages(Data);
      } else {
        console.error("Error fetching filtered data");
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  }, []);

  useEffect(() => {
    fetchGalleryImage();
  }, [fetchGalleryImage]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <>
      <div className={`wrapper container mb-4 ${fadeIn ? 'appearLeft' : ''}`}>
        <Slider {...settings} className="image-slider">
          {images.map((image, index) => (
            <div key={index} className="slick-slide">
              <img
                src={`/ImageGallery/${image.ImageURL}?timestamp=${new Date().getTime()}`}
                alt={image.ImageTitle} className='img1'
              />
            </div>
          ))}
        </Slider>
      </div>
    </>
  )
}
